import { graphql } from '@/generated/gql';

export const INTAKE_CREATE_THREAD = graphql(/* GraphQL */ `
  mutation CreateChatThread($data: SvbrgThreadCreateInput!) {
    sevenbridges {
      thread {
        create(data: $data) {
          id
        }
      }
    }
  }
`);
